const filenameArray = [
    'close.svg',
    'ft-longi-logo.png',
    'gnosis2.svg',
    'person1@2x.png',
    'person3@2x.png',
    'person5@2x.png',
    'person7@2x.png',
    'person9@2x.png',
    'small-planet.png',
    'star.png',
    'download-icon.svg',
    'gnosis1.svg',
    'grid.png',
    'person2@2x.png',
    'person4@2x.png',
    'person6@2x.png',
    'person8@2x.png',
    'plus.svg',
    'sub-arrow-right.svg',
    'Gnosis00.png',
    'Gnosis01.png',
    'Gnosis02.png',
    'Gnosis03.png',
    'Gnosis04.png',
    'Gnosis05.png',
    'Gnosis06.png',
    'home.png',
];

const images = Object.fromEntries(filenameArray.map(fn => [fn, undefined]));

export default images;